import files from '@/api/modules/files';

export default {
	async attachFile(context, params) {
		const res = await files.attachFile(params);
		return res;
	}
};
